import { render } from "./NavBarHorizontal.vue?vue&type=template&id=0861f86d&scoped=true"
import script from "./NavBarHorizontal.vue?vue&type=script&lang=js"
export * from "./NavBarHorizontal.vue?vue&type=script&lang=js"

import "./NavBarHorizontal.vue?vue&type=style&index=0&id=0861f86d&scoped=true&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0861f86d"]])

export default __exports__